var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow expand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-108.3%",
    y: "-100.0%",
    width: "316.7%",
    height: "316.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-66.7%",
    y: "-58.3%",
    width: "233.3%",
    height: "233.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.166138549 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.196078431   0 0 0 0 0.196078431   0 0 0 0 0.364705882  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "7.0625 0 8 0.9375 4 4.9375 0 0.9375 0.9375 0 4 3.0625"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-expand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(18.000000, 18.000000) scale(-1, 1) translate(-18.000000, -18.000000) translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    filter: "url(#filter-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Dark/Back_Circle",
    transform: "translate(8.500000, 7.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chevron/Down",
    transform: "translate(3.000000, 4.500000) rotate(90.000000) translate(-3.000000, -4.500000) translate(-1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8icon-color/dark",
    mask: "url(#mask-5)",
    fill: "#02669F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.000000, -34.000000)",
    id: "Icon-Shade"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExpand);
export default __webpack_public_path__ + "static/media/Arrow_expand.e94d76c870e2f98559867a2c3f234bc8.svg";
export { ForwardRef as ReactComponent };